import SimpleItemList from "./SimpleItemList";
import {useEffect, useRef, useState} from "react";
import Api from "../services/Api";
import {useInViewport} from "react-in-viewport";
import {Button, Typography, useTheme} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {MobileTooltip} from "./Tooltip";
import Processor from "../services/Processor";
import {Affiliate} from "./Affiliate";

const getItems = async (searchParams, currencyApi, auth) => {
    let entries = 10;
    let keywords = searchParams.get('keywords');
    let category = searchParams.get('category');
    let sort = searchParams.get('sort');
    let minPrice = searchParams.get('minPrice');
    let maxPrice = searchParams.get('maxPrice');
    let currency = searchParams.get('currency');
    let vBlockedCountries = [];
    let vBlockedSellers = [];
    let listingTypes = searchParams.getAll('listingTypes');
    currencyApi.setCurrency('cad');
    let data;
    try {
        data = await Api.fetchItems(auth, keywords, category, sort, 0, entries, minPrice, maxPrice, listingTypes,
            currency, vBlockedSellers, vBlockedCountries, undefined, undefined, true);
    } catch (e) {
        throw 'Server error';
    }
    if (!data?.itemSummaries) {
        throw 'eBay Server error';
    }
    data = await Processor.convertPrices(data.itemSummaries, currencyApi);
    return data ?? [];
}

export const SimpleItemListRow = ({
                                      handlePreload,
                                      setSearchParams,
                                      subtitle,
                                      handleToggle,
                                      preload,
                                      currentItem,
                                      recentItems,
                                      currentOverlayId,
                                      setCurrentOverlayId,
                                      title,
                                      url,
                                      count,
                                      currencyApi,
                                      auth,
                                      noUser,
                                      rows, titleRef
                                  }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const myRef = useRef(null);
    const {inViewport} = useInViewport(myRef, {rootMargin: "0px"});
    const theme = useTheme();
    useEffect(() => {
        if (!inViewport || !loading || loaded) return;
        if (currencyApi && auth) {
            const searchParams = new URLSearchParams(url);
            (async () => {
                setLoading(true);
                try {
                    const data = await getItems(searchParams, currencyApi, auth);
                    setLoading(false);
                    setItems(data);
                } finally {
                    setLoaded(true);
                }

            })();
        }
    }, [currencyApi, auth, inViewport, loading, loaded])

    return (
        <div ref={myRef}>
            <div className={"ItemListRowTitle"} ref={titleRef}
                 style={{backgroundColor: theme.palette.background.default}}>
                <span className={"ItemListRowTitleInner"}>
                    <MobileTooltip placement={"right"} enterDelay={500} title={"Search"}>
                    <Button startIcon={<SearchIcon/>}
                            onClick={() => setSearchParams(new URLSearchParams(url))}>{title}</Button>
                    </MobileTooltip>
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
                    {noUser && <Affiliate style={{margin: 0, marginBottom: -6, marginTop: 6, justifyContent: "left"}} maxWidth={500}/>} 
                    </span>
            </div>
            <SimpleItemList loading={loading} rows={rows} count={count ?? 4} alwaysShow={false}
                            currentOverlayId={currentOverlayId} setCurrentOverlayId={setCurrentOverlayId}
                            currentItem={currentItem} recentItems={recentItems} preload={preload}
                            handlePreload={handlePreload}
                            items={items} handleToggle={handleToggle} setLoading={setLoading}
                            sort={'WatchCountDecreaseSort'}/>
        </div>
    )
}